import { useEffect, useRef, useState } from "react";
import LoadingOverlay from "react-loading-overlay-ts";
import { useSelector, useDispatch } from "react-redux";
import { Column } from "primereact/column";
import _, { isEmpty, uniq } from "lodash";
import { useNavigate } from "react-router-dom";
import { Toast } from "primereact/toast";

import DataTableGrid from "../../common/DataTableGrid/DataTableGrid";
import "./CapacityManagementPlaningHeader.scss";
import { getPlanningTaskLists, getPlanningProjectLists } from "../../../apis/acpApi";
import filter from "../../../assets/images/filter.svg";
import blueFilter from "../../../assets/images/BlueFilterIcon.svg";
import { ProjectService } from "../../../service/PegaService";
import TaskbodyTemplate from "./TaskbodyTemplate";
import { AcpService } from "../../../service/ACPService";
import AcpCloseDialog from "../common/AcpCloseDialog";
import { SaveChangesConfirmation, excludedColumnsACP } from "../constant";
import ACPFilter from "../common/ACPFilter";
import { formCustomizeObject, multiFilterChange, changeDateFormat } from "../../../utils";

import {
  setAcpPlanningTaskDraftData,
  setAcpPlanningProjectDraftData,
  acpPlanningProjectData,
  acpPlanningData as setStoreAcpTask,
} from "../../../store/actions/AcpPlanningActions";
import { findDraftProjectData, findDraftTaskData } from "../../../service/ACPplanningService";
import { AcpCommonService } from "../../../service/AcpCommonService";
import { removeObjectsWithNullNewStartDate } from "../../../service/DashboardService";
import { UnsavedChangesDialog, useUnsavedChangesWarning } from "../../common/NavigationPrompt";
import { onACPColumnResizeEnd, replaceUnderscoreWithSpace, storeACPReorderedColumns, updateFieldData } from "../utils";
import CustomizeView from "../../common/CustomizeView";
import { getColumnsOrder, setColumnsOrder } from "../../../apis/commonApi";

const TaskAndProjectListNavigation = ({
  setActiveTabSection,
  setIsProjectData,
  setIsProjectListTab,
  setIsTaskData,
  saveChangesOption,
  setSaveChangesOption,
  loadTaskTable,
  loadProjectTable,
  setLoadProjectTable,
  setPlanningData,
  isSearch,
  acpFilters,
  task,
  supplierValue,
  reset,
  setReset,
  setActiveTable,
  filters,
  setFilters,
  selectedTask,
  setSelectedTask,
  selectedProject,
  setSelectedProject,
  PM,
  UserGroup,
  setFormValid,
  saveFlag,
  setSaveFlag,
  isTaskData,
  isProjectData,
  showDraftDialog,
  setShowDraftDialog,
  tabName,
  clearAllFilter,
  setClearAllFilter,
  taskData,
  setTaskData,
  setApplyFilters,
  changingTab,
  setChangingTab,
  setTabName,
  setLoadTaskTable,
  checkReadWriteAccess,
  resetKey,
  setResetKey,
  setDateChangeValue,
  allEditedRowsPlanning,
  setAllEditedRowsPlanning,
  ShowCustomizedView,
  setShowCustomizedView,
  setHeaders,
  availableAcpColumns,
  setInitiapPegaData,
  setSupplier,
  parentFilter,
  capacityPlanWrapFreeText,
  setcapacityPlanWrapFreeText,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const op = useRef(null);
  const toast = useRef(null);
  const colAllSelectedP = useRef([]);
  const selectedColumnListP = useRef([]);
  const selectedFieldsRefP = useRef([]);
  const filterArrayP = useRef([]);
  const [activeSection, setActiveSection] = useState("ProjectList");
  const [loader, setLoader] = useState(false);
  const { acpPlanningData, acpPlanningProjectListData, acpPlanningProjectListDataRaw, taskDraftChanges, projectDraftChanges } =
    useSelector((state) => state?.AcpPlanningReducer);
  const [TaskColumnNames, setTaskColumnNames] = useState([]);
  const [ProjectColumnNames, setProjectColumnNames] = useState([]);
  const [projectData, setProjectData] = useState([]);
  const [InitialProjectData, setInitialProjectData] = useState([]);
  const [InitialTaskData, setInitialTaskData] = useState([]);

  const [selectAllChecked, setSelectAllChecked] = useState(false);
  const [showCloseDialog, setShowCloseDialog] = useState(false);
  const [selectedColumnName, setSelectedColumnName] = useState("SelectAll");
  const [sortData, setSortData] = useState([]);
  const [selectedFields, setSelectedFields] = useState({});

  const [startDate, setStartDate] = useState(acpFilters?.startDate);
  const [endDate, setEndDate] = useState(acpFilters?.endDate);
  const [Toggle, setToggle] = useState(false);
  const [conditionMatched, setConditionMatched] = useState(false);
  const [forceRefresh, setForceRefresh] = useState(0);

  const [payload, setPayload] = useState({});
  const query = AcpService.useQuery();
  const { endDateQueryParams, startDateQueryParams, supplierQueryParams, taskTypeQueryParams } = AcpService.decodedParams(query);
  const [planningPageEdited, setPlanningPageEdited] = useState(false);
  const { markDirty, markClean } = useUnsavedChangesWarning();
  const [showDialog, setShowDialog] = useState(false);
  const [tempUrl, setTempUrl] = useState("");
  const [action, setAction] = useState("");
  const [currentClick, setCurrentClick] = useState("");
  const [tableRender, setTableRender] = useState(false);
  const [region, setRegion] = useState("");
  const [bu, setBu] = useState("");
  const TaskListColumnNames = ProjectService.getAvailablePlanningColumnNames();
  const ProjectListColumnNames = ProjectService.getAvailablePlanningProjectColumnNames();

  const [pgDefaultColumnsTaskList, setPgDefaultColumnsTaskList] = useState({});
  const [frozenColumnTaskList, setFrozenColumnTaskList] = useState(["SelectAll"]);
  const [customizeViewFieldsTaskList, setCustomizeViewFieldsTaskList] = useState({});
  const [availableColumnNamesTaskList, setAvailableColumnNamesTaskList] = useState([]);
  const [InitAvailableColumnsTaskList, setInitAvailableColumnsTaskList] = useState([]);

  const [pgDefaultColumnsProjectList, setPgDefaultColumnsProjectList] = useState({});
  const [frozenColumnProjectList, setFrozenColumnProjectList] = useState(["SelectAll"]);
  const [customizeViewFieldsProjectList, setCustomizeViewFieldsProjectList] = useState({});
  const [availableColumnNamesProjectList, setAvailableColumnNamesProjectList] = useState([]);
  const [InitAvailableColumnsProjectList, setInitAvailableColumnsProjectList] = useState([]);

  const updateCustomizeViewFields = (availableColumns, selectedColumns, frozenColumns, TabType) => {
    const customizeViewData = getCustomizeViewObj(availableColumns, selectedColumns, frozenColumns);
    if (TabType === "customizeViewFieldsTaskList") {
      setCustomizeViewFieldsTaskList(JSON.stringify(customizeViewData));
    } else if (TabType === "customizeViewFieldsProjectList") {
      setCustomizeViewFieldsProjectList(JSON.stringify(customizeViewData));
    }
    localStorage.setItem(TabType, JSON.stringify(customizeViewData));
  };
  const getCustomizeViewObj = (availableColumns, selectedColumns, frozenColumns) => {
    const customizeViewObj = {
      availableFields: {
        id: "availableFields",
        title: "Available Fields",
        fieldsData: availableColumns,
      },
      selectedFields: {
        id: "selectedFields",
        title: "Selected Fields",
        fieldsData: selectedColumns,
      },
      freezedColumns: {
        id: "freezedColumns",
        title: "Freezed Fields",
        fieldsData: frozenColumns,
      },
    };
    return customizeViewObj;
  };

  const updateInObjectFormat = (columns, frozenCoulmns) => {
    return columns?.map((el, i) => {
      return {
        sequence: i + 1,
        Sequence: "",
        Field_Name: el,
        reorder: false,
        Column_Name: el,
        sortAtoZ: false,
        sortZtoA: false,
        Attribute_Type: "Free Text",
        freeze: frozenCoulmns.includes(el) ? true : false,
      };
    });
  };

  const updatedFrozenColumn = (frozenArr) => {
    const fronzenFields = frozenArr?.map((el) => {
      //el = el?.replace(/_/g, " ");
      return el;
    });
    if (activeSection === "TaskList") {
      setFrozenColumnTaskList(fronzenFields);
    } else if (activeSection === "ProjectList") {
      setFrozenColumnProjectList(fronzenFields);
    }
  };

  const convertObjToNormalFormat = (columns) => {
    return columns?.map((el) => el?.Field_Name);
  };

  const addUniqueKey = (data) => {
    return data?.map((el, i) => {
      return {
        ...el,
        UniqueID: i,
      };
    });
  };

  useEffect(() => {
    if (startDateQueryParams && endDateQueryParams) {
      const payload2 = {
        ArtworkAgilityPage: {
          PM: PM,
          UserGroup: UserGroup,
          End_Date: endDateQueryParams,
          Start_Date: startDateQueryParams,
        },
      };
      setPayload(payload2);
    } else if (
      acpFilters?.startDate &&
      acpFilters?.endDate &&
      !startDateQueryParams &&
      !endDateQueryParams
    ) {
      const payload1 = {
        ArtworkAgilityPage: {
          PM: PM,
          UserGroup: UserGroup,
          End_Date: acpFilters?.endDate,
          Start_Date: acpFilters?.startDate,
        },
      };
      setPayload(payload1);
    }
  }, [startDateQueryParams, endDateQueryParams, acpFilters?.startDate, acpFilters?.endDate]);

  useEffect(() => {
    if (acpPlanningProjectListData.length > 0) {
      let datawithDraftChanges = findDraftProjectData(
        acpPlanningProjectListData,
        projectDraftChanges,
        isProjectData
      );
      const updatedDataWithDraftChange = addUniqueKey(datawithDraftChanges);
      setInitialProjectData(updatedDataWithDraftChange);
      if (!sortData?.length) {
        setProjectData(updatedDataWithDraftChange);
      }
    }
  }, [acpPlanningProjectListData, projectDraftChanges]);

  useEffect(() => {
    if (clearAllFilter) {
      setFilters([]);
      //setSortData([]);
      clearAppliedFilters();
      setSelectedFields({});
      setClearAllFilter(false);
    }
  }, [clearAllFilter]);

  useEffect(() => {
    if (selectedTask?.length === 0 && selectedProject?.length === 0) setSelectAllChecked(false);
     (selectedTask?.length > 0 || selectedProject?.length > 0) ? setSaveChangesOption(true) :setSaveChangesOption(false)
  }, [selectedTask, selectedProject]);

  const applyTaskFilter = (filteredData) => {
    // const updatedFilteredData = addUniqueKey(filteredData);

    let _updatedSortedData = filteredData;
    let _updatedFilteredData = filteredData;
    if (sortData?.length) {
      _updatedSortedData = AcpService.sortDataOnDemand(filteredData, sortData?.[0], sortData?.[1]);
    }
    if (allEditedRowsPlanning?.length) {
      _updatedFilteredData = AcpCommonService.includeChangesInMainDataSet(
        _updatedSortedData,
        allEditedRowsPlanning
      );
    } else {
      _updatedFilteredData = _updatedSortedData;
    }

    if (task) {
      if (task !== "All Tasks") {
        if (task === "Upload CIC") {
          setTaskData(
            _updatedFilteredData?.filter((ele) => ele.TaskType?.toLowerCase().includes("cic"))
          );
          setInitialTaskData(
            _.cloneDeep(filteredData?.filter((ele) => ele.TaskType?.toLowerCase().includes("cic")))
          );
        } else if (task === "FA Assembly") {
          setTaskData(
            _updatedFilteredData?.filter((ele) => ele.TaskType?.toLowerCase().includes("assembly"))
          );
          setInitialTaskData(
            _.cloneDeep(
              filteredData?.filter((ele) => ele.TaskType?.toLowerCase().includes("assembly"))
            )
          );
        }
      } else {
        setInitialTaskData(_.cloneDeep(filteredData));
        setTaskData(_updatedFilteredData);
      }
    } else {
      // no task assigned yet
      setInitialTaskData(_.cloneDeep(filteredData));
      setTaskData(_updatedFilteredData);
    }
  };

  const updateTopAndBottomFilterLogic = (filteredData) => {
    if (selectedFieldsRefP.current?.length) {
      const filterData = AcpService.filterDataByfilters(
        filteredData,
        selectedFieldsRefP.current,
        setConditionMatched,
        tabName
      );
      // if (!sortData?.length) {
        setFilters(filterData);
      // }
      selectedColumnListP.current = filterData;
    }
  };

  useEffect(() => {
    // making sure that this part will be only called
    // in case of activeSection === "TaskList", because
    // ProjectList don't have Top supplier and Tasks selection
    if (activeSection === "TaskList") {
      updateTopAndBottomFilterLogic(taskData);
    }
  }, [taskData]);

  useEffect(() => {
    let updatedAllColumns = convertObjToNormalFormat(getColumnNames(activeSection)).filter(
      (el) => el !== "SelectAll"
    );
    if (updatedAllColumns?.length) {
      setHeaders(updatedAllColumns?.map((item) => replaceUnderscoreWithSpace(item)));
    }
  }, [customizeViewFieldsProjectList, customizeViewFieldsTaskList]);

  const applyTaskAndSupplierFilter = () => {
    let filteredData;
    const _acpPlanningDataWithKeys = addUniqueKey(acpPlanningData);
    let datawithDraftChanges = findDraftTaskData(
      _acpPlanningDataWithKeys,
      taskDraftChanges,
      isTaskData
    );
    if (supplierValue) {
      //if supplier exists
      if (supplierValue !== "Select Supplier") {
        if (supplierValue === "NA") {
          filteredData = datawithDraftChanges?.filter((ele) => ele.Supplier?.toLowerCase() === "");
          applyTaskFilter(filteredData);
        } else {
          filteredData = datawithDraftChanges?.filter(
            (ele) => ele?.Supplier?.toLowerCase() === supplierValue?.toLowerCase()
          );
          applyTaskFilter(filteredData);
        }
      } else {
        // value of Select Supplier
        applyTaskFilter(datawithDraftChanges);
      }
    } else {
      // no supplier set yet
      applyTaskFilter(datawithDraftChanges);
    }
  };

  useEffect(() => {
    if (acpPlanningData.length > 0) {
      setSelectedColumnName("SelectAll");
      applyTaskAndSupplierFilter();
    }
  }, [task, supplierValue, acpPlanningData, taskDraftChanges]);

  useEffect(() => {
    if (acpFilters?.startDate && acpFilters?.endDate) {
      setStartDate(acpFilters?.startDate);
      setEndDate(acpFilters?.endDate);
      setFilters([]);
      // Force refresh when dates change to ensure fresh data
      setForceRefresh(prev => prev + 1);
    }
  }, [acpFilters?.startDate, acpFilters?.endDate]);

  const handleClick = (buttonName) => {
    if (planningPageEdited && buttonName !== activeSection) { 
      setShowDialog(true);
      setAction("TabChange");
      setCurrentClick(buttonName);
      setSaveChangesOption(false);
    } else { 
      setFilters([]);
      if (saveChangesOption) {
        setShowCloseDialog(true);
      }
      if (buttonName === "TaskList" && !saveChangesOption) {
        setActiveSection("TaskList");
        setActiveTabSection("TaskList")
        setActiveTable("TaskList");
        setIsProjectListTab(false);
        // Force refresh when switching to TaskList
        setForceRefresh(prev => prev + 1);
      } else if (buttonName === "ProjectList" && !saveChangesOption) {
        setActiveSection("ProjectList");
        setActiveTabSection("ProjectList")
        setActiveTable("ProjectList");
        setIsProjectListTab(true);
        // Force refresh when switching to ProjectList
        setForceRefresh(prev => prev + 1);
      }
    }
  };

  const onSort = (column, direction, filterData, clearedGlobalFilter, clickedCanceled) => {
    const tableData = activeSection === "TaskList" ? taskData : projectData;
    const dataToBeSorted = filterData?.length
      ? filterData
      : filters?.length && !clearedGlobalFilter
        ? filters
        : tableData;
    let updatedData = AcpService.sortDataOnDemand(dataToBeSorted, column, direction);

    if (clickedCanceled) {
      updatedData = updatedData?.map((el) => {
        return {
          ...el,
          NewStartDate: "",
          isSelected: false,
          tempNewStartDate: "",
          Slack: el?.tempSlack ? el.tempSlack : 0,
        };
      });
    }

    setSortData([column, direction]);
    localStorage.setItem("sortedColumnPlanning", JSON.stringify(true));
    // due to 3077
    if ((filters?.length || filterData?.length) && !clearedGlobalFilter) {
      setFilters(updatedData);
      selectedColumnListP.current = updatedData;
    } else {
      if (activeSection === "TaskList") {
        setTaskData(updatedData);
      } else {
        let datawithDraftChanges = findDraftProjectData(
          updatedData,
          projectDraftChanges,
          isProjectData
        );
        setProjectData(datawithDraftChanges);
      }
    }
  };

  const onGlobalFilterChange = (e, colName) => {
    const data = activeSection === "ProjectList" ? projectData : taskData;
    //changing the date format for Projected_FA_FullKit_Date due to filter issue
    const activeData = data?.map(item => {
      return {
        ...item,
        Projected_FA_FullKit_Date: changeDateFormat(item?.Projected_FA_FullKit_Date),
        POA_Release_Date: changeDateFormat(item?.POA_Release_Date),
        DSBP_PMP_ArtworkDate: changeDateFormat(item?.DSBP_PMP_ArtworkDate),
        DSBP_PMP_FPC_SOS: changeDateFormat(item?.DSBP_PMP_FPC_SOS),
        DSBP_PMP_FPC_SOSDate: changeDateFormat(item?.DSBP_PMP_FPC_SOSDate),
        RTA_Color_Seperation_Date: changeDateFormat(item?.RTA_Color_Seperation_Date),

      }
    });
    const { value, multiplesFlag, arr } = multiFilterChange(
      e,
      colName,
      selectedColumnName,
      selectedFields,
      setSelectedFields,
      activeData,
      filterArrayP,
      selectedColumnListP,
      colAllSelectedP,
      selectedFieldsRefP
    );
    // putting null array check, when there is all filter cleared
    const _selectedFieldsRef = (selectedFieldsRefP?.current || [])?.map((el, i) => {
      if (Object.keys(arr)?.[0] === Object.keys(el)?.[0]) {
        return {
          ...el,
          [`${selectedColumnName}`]: arr[selectedColumnName],
        };
      } else {
        return el;
      }
    });
    if (AcpService.areAllPropertiesEmptyArrays(_selectedFieldsRef)) {
      localStorage.removeItem("_selectedFieldsRefCurrentPlanning");
    }
    if (filterArrayP.current?.length) {
      if ((value?.length > 0 && !multiplesFlag) || colAllSelectedP.current?.length >= 1) {
        const _selectedFieldsRefWithoutEmptyArray =
          AcpService.removeEmptyArrays(_selectedFieldsRef);
        const filterData = AcpService.filterDataByfilters(
          activeData,
          _selectedFieldsRefWithoutEmptyArray,
          setConditionMatched,
          tabName
        );
        const updatedFilterArray = AcpService.updateStartDateFormat(filterData);
        if (filterData?.length && sortData?.length) {
          onSort(sortData[0], sortData[1], filterData);
        } else {
          setFilters(updatedFilterArray);
          selectedColumnListP.current = updatedFilterArray;
        }
      } else {
        selectedColumnListP.current = [];
        setSelectedFields({});
        setFilters([]);
      }
    } else {
      selectedColumnListP.current = [];
      setSelectedFields({});
      setFilters([]);
    }
  };

  const clearColumnWiseFilter = () => {
    let _selectedColumnName = selectedColumnName;
    const finalTaskData = _.cloneDeep(InitialTaskData);
    const finalProjectData = _.cloneDeep(InitialProjectData);
    let updatedFilteredDataTask = finalTaskData;
    let updatedFilteredDataProject = finalProjectData;
    if (allEditedRowsPlanning?.length && (finalTaskData?.length || finalProjectData?.length)) {
      updatedFilteredDataTask = AcpCommonService.includeChangesInMainDataSet(
        finalTaskData,
        allEditedRowsPlanning
      );

      updatedFilteredDataProject = AcpCommonService.includeChangesInMainDataSet(
        finalProjectData,
        allEditedRowsPlanning
      );
    }
    // to handle if filters exists
    // even if filter exists the data will always be tableData,
    // and on clear filter calculation will be done from tableData only
    const activeData =
      activeSection === "ProjectList"
        ? allEditedRowsPlanning.length
          ? updatedFilteredDataProject
          : finalProjectData
        : allEditedRowsPlanning.length
          ? updatedFilteredDataTask
          : finalTaskData;
    const selectedFields2 = _.cloneDeep(selectedFields);
    const _selectedFields = AcpService.emptyProperty(selectedFields2, _selectedColumnName);
    const __selectedFields = AcpCommonService.removeEmptyArraysWithNoData(_selectedFields);
    if (sortData && sortData?.length && sortData[0] === _selectedColumnName) {
      localStorage.removeItem("sortedColumnPlanning");
      setSortData([]);
      if (Object.keys(__selectedFields)?.length === 0) {
        setClearAllFilter(true);
      }
    }
    //3078
    let data = [];
    if (Object.keys(__selectedFields)?.length) {
      data = [...(activeData || [])];
      Object.keys(__selectedFields).forEach((el) => {
        if (__selectedFields[el]?.length) {
          data = data?.filter((ele) => {
            let dateFormatDDMMYY = "";
            // Changing date format as if date is not in DDMMYYY
            // then first convert and then compare the dates
            if (
              selectedColumnName === "CurrentStartDate" ||
              selectedColumnName === "EstimatedAWReadiness"
            ) {
              dateFormatDDMMYY = AcpService.checkIfValidDate(ele[el])
                ? ele[el]
                : !AcpService.isUBN(ele[el])
                  ? AcpService.convertToShortDateFormat(ele[el])
                  : "";
              return __selectedFields[el].includes(dateFormatDDMMYY);
            } else {
              return __selectedFields[el].includes(ele[el]);
            }
          });
        }
      });
    }
    if (data?.length && Object.keys(__selectedFields)?.length) {
      // for ProjectList the default sorting is  with EstimatedAWReadiness, asc
      // and for TaskList default sorting is StartDate with asc
      // updating sort logic for sortData?.[0] !== _selectedColumnName
      const customColumn =
        sortData?.length && sortData?.[0] !== _selectedColumnName
          ? sortData?.[0]
          : activeSection === "ProjectList"
            ? "EstimatedAWReadiness"
            : "StartDate";
      const direction =
        sortData?.length && sortData?.[0] !== _selectedColumnName ? sortData?.[1] : "asc";
      // if there is no sort then default sort for tasklist will be StartDate asc,
      // and for ProjectList will be EstimatedAWReadiness asc,
      // but if there sort then it will go as per sort
      if (filters?.length) {
        // if there is sort and filter both applied on seperate columns,
        // then on clearing filtercolumn wise, we need data should be sorted but
        // with StartDate for TaskList and EstimatedAWReadiness for ProjectList
        // as it remains on initial page load
        data = AcpService.sortDataOnDemand(data, customColumn, direction);
      }
      setFilters(data);
    } else if (sortData?.length && sortData[0] !== _selectedColumnName) {
      selectedColumnListP.current =
        activeSection === "ProjectList"
          ? allEditedRowsPlanning.length
            ? updatedFilteredDataProject
            : finalProjectData
          : allEditedRowsPlanning.length
            ? updatedFilteredDataTask
            : finalTaskData;

      let finalData =
        activeSection === "ProjectList"
          ? allEditedRowsPlanning.length
            ? updatedFilteredDataProject
            : finalProjectData
          : allEditedRowsPlanning.length
            ? updatedFilteredDataTask
            : finalTaskData;

      // here channging the logic as that data should be sorted based on StartDate
      finalData = AcpService.sortDataOnDemand(finalData, sortData?.[0], sortData?.[1]);

      activeSection === "ProjectList" ? setProjectData(finalData) : setTaskData(finalData);
      setFilters([]);
      //3182
    } else {
      setFilters([]);
      // const finalTaskData = _.cloneDeep(InitialTaskData);
      // const finalProjectData = _.cloneDeep(InitialProjectData);
      if (allEditedRowsPlanning?.length) {
        updatedFilteredDataTask = AcpCommonService.includeChangesInMainDataSet(
          finalTaskData,
          allEditedRowsPlanning
        );

        updatedFilteredDataProject = AcpCommonService.includeChangesInMainDataSet(
          finalProjectData,
          allEditedRowsPlanning
        );
      }

      selectedColumnListP.current =
        activeSection === "ProjectList"
          ? allEditedRowsPlanning.length
            ? updatedFilteredDataProject
            : finalProjectData
          : allEditedRowsPlanning.length
            ? updatedFilteredDataTask
            : finalTaskData;
      activeSection === "ProjectList"
        ? setProjectData(
          allEditedRowsPlanning.length ? updatedFilteredDataProject : finalProjectData
        )
        : setTaskData(allEditedRowsPlanning.length ? updatedFilteredDataTask : finalTaskData);
    }
    setConditionMatched(false);
    //3182
    setSelectedFields(__selectedFields);
    selectedFieldsRefP.current =[ __selectedFields];
    if (AcpService.areAllPropertiesEmptyArrays(__selectedFields)) {
      localStorage.removeItem("_selectedFieldsRefCurrentPlanning");
    }
  };

  const clearAppliedFilters = () => {
    setFilters([]);
    //setSortData([]);
    setSelectedFields({});
    setClearAllFilter(true);
    setConditionMatched(false);
    selectedFieldsRefP.current = {};
    selectedColumnListP.current = [];
    localStorage.removeItem("sortedColumnPlanning");
    localStorage.removeItem("_selectedFieldsRefCurrentPlanning");
  };

  const fetchData = async (payload) => {
    const res = await getPlanningTaskLists(payload);
    setLoader(false);
    if (res.length) {
      updateSupplierData(res)
      setLoader(false);
      setSelectAllChecked(false);
      setSelectedTask([]);
      setSelectedProject([]);
      setIsTaskData([]);
      setPlanningData((prev) => ({
        ...prev,
        isTask: true,
        planningData: [...acpPlanningData],
      }));
      setSelectedProject([]);
    } else {
      setPlanningData((prev) => ({
        ...prev,
        isTask: true,
        planningData: [],
      }));
      setTaskData([]);
      setSelectedTask([]);
      setSelectedProject([]);
      setIsTaskData([]);
      setLoader(false);
    }
  };

  const fetchProjectListData = (payload) => {
    const res = acpPlanningProjectListDataRaw?.length && acpPlanningProjectListDataRaw;
    setLoader(false);
    if (res) {
      setSelectAllChecked(false);
      setSelectedTask([]);
      setSelectedProject([]);
      setIsProjectData([]);
      let datawithDraftChanges = findDraftProjectData(
        res,
        projectDraftChanges,
        isProjectData
      );
      const updatedDataWithDraftChange = addUniqueKey(datawithDraftChanges);
      setInitialProjectData(updatedDataWithDraftChange);
      setProjectData(updatedDataWithDraftChange);
      setPlanningData((prev) => ({
        ...prev,
        isTask: false,
        planningData: [...acpPlanningProjectListData],
      }));
    } else {
      setPlanningData((prev) => ({
        ...prev,
        isTask: true,
        planningData: [],
      }));
      setSelectedTask([]);
      setSelectedProject([]);
      setIsProjectData([]);
    }
  };
  const projectNameOnClick = (e, options) => {
    op.current.toggle(e);
    setSelectedColumnName(options);
  };

  const fetch = (payload) => {
    clearAppliedFilters();
    if (activeSection === "ProjectList") {
      setLoader(true);
      
      // Make fresh API call for ProjectList to get latest data
      (async () => {
        try {
          // Add timestamp to ensure fresh API call and prevent caching
          const projectPayload = {
            ...payload,
            timestamp: Date.now(),
            forceRefresh: true
          };
          
          const res = await getPlanningProjectLists(projectPayload);
          
          if (res && res.length) {
            // Redux store is already updated in the API function, no need to dispatch again
            
            setSelectAllChecked(false);
            setSelectedTask([]);
            setSelectedProject([]);
            setIsProjectData([]);
            let datawithDraftChanges = findDraftProjectData(
              res,
              projectDraftChanges,
              isProjectData
            );
            const updatedDataWithDraftChange = addUniqueKey(datawithDraftChanges);
            setInitialProjectData(updatedDataWithDraftChange);
            setProjectData(updatedDataWithDraftChange);
            setPlanningData((prev) => ({
              ...prev,
              isTask: false,
              planningData: [...res],
            }));
          } else {
            setPlanningData((prev) => ({
              ...prev,
              isTask: false,
              planningData: [],
            }));
            setProjectData([]);
            setSelectedTask([]);
            setSelectedProject([]);
            setIsProjectData([]);
          }
          setLoader(false);
        } catch (error) {
          console.error('Error fetching project list data:', error);
          setLoader(false);
          setPlanningData((prev) => ({
            ...prev,
            isTask: false,
            planningData: [],
          }));
          setProjectData([]);
        }
      })();
    } else if (activeSection === "TaskList") {
      setLoader(true);
      // fetchData();

      (async () => {
        try {
          const res = await getPlanningTaskLists(payload);
          
          if (res.length) {
            updateSupplierData(res)
            setLoader(false);
            setSelectAllChecked(false);
            setSelectedTask([]);
            setSelectedProject([]);
            setIsTaskData([]);
            setPlanningData((prev) => ({
              ...prev,
              isTask: true,
              planningData: [...acpPlanningData],
            }));
            setSelectedProject([]);
          } else {
            setPlanningData((prev) => ({
              ...prev,
              isTask: true,
              planningData: [],
            }));
            setTaskData([]);
            setSelectedTask([]);
            setSelectedProject([]);
            setIsTaskData([]);
            setLoader(false);
          }
        } catch (error) {
          console.error('Error fetching task list data:', error);
          setLoader(false);
        }
      })();
    }
  };

  const updateSupplierData = (res) => {
    setInitiapPegaData(res);
    let SupplierValue = res.map((el) => {
      let val = el.Supplier.length > 0 ? el.Supplier : "NA";
      return val;
    });
    let uniqueSuppliers = uniq(SupplierValue);
    if (supplierQueryParams && parentFilter?.selectedTask !== taskTypeQueryParams) {
      setSupplier([supplierQueryParams]);
    } else {
      setSupplier(uniqueSuppliers);
    }
  }

  useEffect(() => {
    if (sortData?.length) {
      onSort(sortData[0], sortData[1], [], clearAllFilter, reset);
    }
    if (reset || allEditedRowsPlanning?.length === 0) {
      setPlanningPageEdited(false);
    }
  }, [saveFlag, allEditedRowsPlanning?.length, clearAllFilter, reset]);

  // Main useEffect for data fetching
  useEffect(() => {
    setLoader(true);
    if (startDate && endDate && UserGroup?.length && activeSection) {
      const payload1 = {
        ArtworkAgilityPage: {
          PM: PM,
          UserGroup: UserGroup,
          End_Date: endDateQueryParams ? endDateQueryParams : endDate,
          Start_Date: startDateQueryParams ? startDateQueryParams : startDate,
        },
      };
      fetch(payload1);
    }
  }, [endDate, startDate, activeSection, endDateQueryParams, startDateQueryParams, forceRefresh, UserGroup, PM]);

  // Additional useEffect specifically for date changes to ensure fresh data
  useEffect(() => {
    if (startDate && endDate && UserGroup?.length && activeSection) {
      const payload = {
        ArtworkAgilityPage: {
          PM: PM,
          UserGroup: UserGroup,
          End_Date: endDateQueryParams ? endDateQueryParams : endDate,
          Start_Date: startDateQueryParams ? startDateQueryParams : startDate,
        },
      };
      // Small delay to ensure state updates are processed
      setTimeout(() => {
        fetch(payload);
      }, 100);
    }
  }, [startDate, endDate]);

  const getCustomizeViewFieldsType = (currentActiveSection) => {
    return currentActiveSection === "TaskList"
      ? "customizeViewFieldsTaskList"
      : "customizeViewFieldsProjectList";
  };

  const getCustomizeViewFieldsValue = (currentActiveSection) => {
    return currentActiveSection === "TaskList"
      ? customizeViewFieldsTaskList
      : customizeViewFieldsProjectList;
  };

  const getPgDefaultValue = (currentActiveSection) => {
    return currentActiveSection === "TaskList"
      ? pgDefaultColumnsTaskList
      : pgDefaultColumnsProjectList;
  };

  const getColumnListColumnNames = (currentActiveSection) => {
    return currentActiveSection === "TaskList" ? TaskListColumnNames : ProjectListColumnNames;
  };

  const getColumnNames = (currentActiveSection) => {
    return currentActiveSection === "TaskList" ? TaskColumnNames : ProjectColumnNames;
  };

  const getFrozenColumnNames = (currentActiveSection) => {
    return currentActiveSection === "TaskList" ? frozenColumnTaskList : frozenColumnProjectList;
  };

  const getInitFreezeColumn = () => {
    return ["SelectAll"];
  };

  const getInitAvailableColumnNames = (currentActiveSection) => {
    return currentActiveSection === "TaskList"
      ? InitAvailableColumnsTaskList
      : InitAvailableColumnsProjectList;
  };

  const getLocalStorageACPPlanningColumnNames = (currentActiveSection) => {
    return currentActiveSection === "TaskList"
      ? "ACPPlanningTaskColumnNames"
      : "ACPPlanningProjectColumnNames";
  };

  const getAvailableColumnNames = (currentActiveSection) => {
    return currentActiveSection === "TaskList"
      ? availableColumnNamesTaskList
      : availableColumnNamesProjectList;
  };

  const updateAvailableAndInitAvialableColumnsNames = (
    currentActiveSection,
    availableFieldsToSelectInObjFormat
  ) => {
    if (currentActiveSection === "TaskList") {
      setAvailableColumnNamesTaskList(availableFieldsToSelectInObjFormat);
      setInitAvailableColumnsTaskList(availableFieldsToSelectInObjFormat);
    } else {
      setAvailableColumnNamesProjectList(availableFieldsToSelectInObjFormat);
      setInitAvailableColumnsProjectList(availableFieldsToSelectInObjFormat);
    }
  };

  const updateAvailableColumnsNames = (
    currentActiveSection,
    availableFieldsToSelectInObjFormat
  ) => {
    if (currentActiveSection === "TaskList") {
      setAvailableColumnNamesTaskList(availableFieldsToSelectInObjFormat);
    } else {
      setAvailableColumnNamesProjectList(availableFieldsToSelectInObjFormat);
    }
  };

  const updatePgDefaultColumns = (currentActiveSection, pgDefaultColumnList) => {
    currentActiveSection === "TaskList"
      ? setPgDefaultColumnsTaskList(updateFieldData(pgDefaultColumnList))
      : setPgDefaultColumnsProjectList(updateFieldData(pgDefaultColumnList));
  };

  const updateColumnNames = (currentActiveSection, allSelectedCols) => {
    currentActiveSection === "TaskList"
      ? setTaskColumnNames(allSelectedCols)
      : setProjectColumnNames(allSelectedCols);
  };

  const updateCustomizeViewFieldsOnly = (currentActiveSection, value) => {
    currentActiveSection === "TaskList"
      ? setCustomizeViewFieldsTaskList(value)
      : setCustomizeViewFieldsProjectList(value);
  };

  const removeSelectAllColumn = (arr) => {
    if (arr && arr?.length && arr?.includes("SelectAll")) {
      return arr.filter((el) => el !== "SelectAll");
    } else {
      return arr;
    }
  };

  //AWM-3991-> Planning - Selected to Available not working after refresh
  const updateAvailablefeildsFromPega = (customizeViewColumnFromPega, availableFieldsToSelect) => {
    if (customizeViewColumnFromPega !== null && customizeViewColumnFromPega !== "") {
      const availableData = customizeViewColumnFromPega?.availableFields?.fieldsData;
      let availableFieldsToSelectInObjFormat = [];
      availableFieldsToSelectInObjFormat = updateInObjectFormat(
        availableData,
        getInitFreezeColumn(activeSection)
      );
      updateAvailableAndInitAvialableColumnsNames(activeSection, availableFieldsToSelectInObjFormat);
    }
    else {
      let availableFieldsToSelectInObjFormat = [];
      if (activeSection === "TaskList") {
        availableFieldsToSelectInObjFormat = updateInObjectFormat(
          availableFieldsToSelect,
          getInitFreezeColumn(activeSection)
        );
        updateAvailableAndInitAvialableColumnsNames(
          activeSection,
          availableFieldsToSelectInObjFormat
        );
      } else if (activeSection === "ProjectList") {
        updateAvailableAndInitAvialableColumnsNames(activeSection, []);
      }
    }
  }
  useEffect(() => {
    setIsTaskData([]);
    //reseting the stae
    setIsProjectData([]);
    setAllEditedRowsPlanning([]);
    const tabType = getCustomizeViewFieldsType(activeSection);

    let taskcols = [];
    let projectcols = [];
    taskcols = updateInObjectFormat(
      AcpService.reorderTaskListColumns(getColumnListColumnNames(activeSection)),
      getInitFreezeColumn(activeSection)
    );

    projectcols = updateInObjectFormat(
      AcpService.reorderProjectListColumns(getColumnListColumnNames(activeSection)),
      getInitFreezeColumn(activeSection)
    );

    let bu = "";
    let region = "";
    const resObj = AcpService.getBURegion(UserGroup);
    if (!isEmpty(resObj)) {
      bu = resObj?.bu;
      region = resObj?.region;
      setBu(bu);
      setRegion(region);
    }
    const filteredAvailableCols = availableAcpColumns?.filter(obj => !excludedColumnsACP.includes(obj?.FieldName))
    const availableCols = filteredAvailableCols?.map((item) => item?.FieldName);
    let availableFieldsToSelect = availableCols?.filter(function (objFromA) {
      return !getColumnListColumnNames(activeSection)?.find(function (objFromB) {
        return objFromA === objFromB;
      });
    });
    const fetchCustomizeViewColumnsFromPega = async () => {
      let customizeViewColumnFromPega = await getColumnsOrder(PM, tabType, bu, region);
      updateAvailablefeildsFromPega(customizeViewColumnFromPega, availableFieldsToSelect) //AWM-3991
      if (customizeViewColumnFromPega !== null && customizeViewColumnFromPega !== "") {
        const availableData = customizeViewColumnFromPega?.availableFields?.fieldsData;
        let frozenData = customizeViewColumnFromPega?.freezedColumns?.fieldsData;
        let selectedData = customizeViewColumnFromPega?.selectedFields?.fieldsData;
        selectedData = removeSelectAllColumn(selectedData);
        frozenData = removeSelectAllColumn(frozenData);
        if (!frozenData?.includes("SelectAll")) {
          frozenData = [...getInitFreezeColumn(), ...frozenData];
        }
        const allData = [...frozenData, ...selectedData];
        const allSelectedCols = updateInObjectFormat(allData, frozenData);
        updatedFrozenColumn(frozenData);
        localStorage.setItem(tabType, JSON.stringify(customizeViewColumnFromPega));
        updateCustomizeViewFields(availableData, selectedData, frozenData, tabType);
        updateColumnNames(activeSection, allSelectedCols);
      } else {
        setTaskColumnNames(taskcols);
        setProjectColumnNames(projectcols);
        updateCustomizeViewFields(
          activeSection === "TaskList" ? availableFieldsToSelect : [],
          getColumnListColumnNames(activeSection),
          getFrozenColumnNames(activeSection),
          tabType
        );
      }
    };
    const pgDefaultColumnsList = formCustomizeObject(
      activeSection === "TaskList" ? availableFieldsToSelect : [],
      getInitFreezeColumn(activeSection),
      getColumnListColumnNames(activeSection)
    );
    updatePgDefaultColumns(activeSection, pgDefaultColumnsList);
    if (bu && region) {
      fetchCustomizeViewColumnsFromPega();
    }
  }, [activeSection, UserGroup?.length]);

  const handleProjectSelectAll = (e) => {
    const data = filters?.length ? filters : projectData;
    const updatedData = data?.filter((el) => el?.RequestStatus !== "Awaiting Response");
    if (e.target.checked) {
      updatedData?.map((el) => (el.isSelected = true));
      setSelectAllChecked(true);
      setSelectedProject(updatedData);
    } else {
      updatedData?.map((el) => (el.isSelected = false));
      setSelectAllChecked(false);
      setSelectedProject([]);
    }
  };

  const handleTaskSelectAll = (e) => {
    const data = filters?.length ? filters : taskData;
    const updatedData = data?.filter((el) => el?.RequestStatus !== "Awaiting Response");
    if (e.target.checked) {
      updatedData?.map((el) => (el.isSelected = true));
      setSelectAllChecked(true);
      setSelectedTask(updatedData);
    } else {
      updatedData?.map((el) => (el.isSelected = false));
      setSelectAllChecked(false);
      setSelectedTask([]);
    }
  };

  const handleSelectItem = (item, selectedItems, setSelectedItems, dataLength) => {
    if (selectedItems?.some(ele => ele?.UniqueID === item?.UniqueID)) {
      item.isSelected = false;
      const uniqueSelcted = _.uniqBy(selectedItems, "UniqueID")
      const newSelectedItems = uniqueSelcted?.filter((i) => i?.UniqueID !== item?.UniqueID);
      setSelectedItems(newSelectedItems);
      setSelectAllChecked(false);
    } else {
      item.isSelected = true;
      const selectedList = [...selectedItems, item];
      setSelectedItems(selectedList);
      setSelectAllChecked(selectedList.length === dataLength);
    }
  };

  const handleSelectTask = (item) => {
    handleSelectItem(
      item,
      selectedTask,
      setSelectedTask,
      filters?.length ? filters?.length : acpPlanningData?.length
    );
  };

  const handleSelectProject = (item) => {
    handleSelectItem(
      item,
      selectedProject,
      setSelectedProject,
      filters?.length ? filters?.length : acpPlanningProjectListData?.length
    );
  };

  const handleDateChange = (options, field, value) => {
    //check if selected date is a weekend
    setFormValid(true);
    if (!saveFlag) {
      setSaveFlag(true);
    }
    if (value != null) {
      options.isSelected = true;
    } else {
      options.isSelected = false;
    }
    const updatedOptions = AcpService.slackDataCalculation(options, field, value);
    const temp = structuredClone(updatedOptions);
    //updatedOptions.tempNewStartDate = "";
    //tempNewStartDate to get fromDate
    //NewStartDate to get toDate

    //update isTaskData and isProjectData correctly
    if (activeSection === "TaskList") {
      setIsTaskData((prev) => {
        if (!updatedOptions.tempNewStartDate) {
          updatedOptions.tempNewStartDate = temp.NewStartDate;
          // updatedOptions.NewStartDate = value;
        } else {
          if (!updatedOptions.fromDate) {
            updatedOptions.fromDate = temp.NewStartDate;
          } else {
            updatedOptions.tempNewStartDate = updatedOptions.fromDate;
            updatedOptions.fromDate = temp.NewStartDate;
          }
        }

        if (prev.length > 0) {
          //need to test for RTA tasks as AWMTaskID is "" for RTA and valid AWMTaskID value for AWM tasks
          if (updatedOptions.AWMTaskID === "") {
            //RTA task
            if (prev.findIndex((p) => p.POANumber === updatedOptions.POANumber) !== -1) {
              const updatedData = prev.map((p) =>
                p.POANumber === updatedOptions.POANumber ? { ...p, ...updatedOptions } : p
              );

              return updatedData;
            } else {
              return [...prev, updatedOptions];
            }
          } else {
            //AWM task
            if (prev.findIndex((p) => p.AWMTaskID === updatedOptions.AWMTaskID) !== -1) {
              const updatedData = prev.map((p) =>
                p.AWMTaskID === updatedOptions.AWMTaskID ? { ...p, ...updatedOptions } : p
              );

              return updatedData;
            } else {
              return [...prev, updatedOptions];
            }
          }
        } else {
          return [updatedOptions];
        }
      });
    } else {
      setIsProjectData((prev) => {
        if (!updatedOptions.tempNewStartDate) {
          updatedOptions.tempNewStartDate = temp.NewStartDate;
          // updatedOptions.NewStartDate = value;
        } else {
          if (!updatedOptions.fromDate) {
            updatedOptions.fromDate = temp.NewStartDate;
          } else {
            updatedOptions.tempNewStartDate = updatedOptions.fromDate;
            updatedOptions.fromDate = temp.NewStartDate;
          }
        }

        if (prev.length > 0) {
          if (prev.find((p) => p.AWMProjectID === updatedOptions.AWMProjectID)) {
            const updatedData = prev.map((p) =>
              p.AWMProjectID === updatedOptions.AWMProjectID ? { ...p, ...updatedOptions } : p
            );
            return updatedData;
          } else {
            return [...prev, updatedOptions];
          }
        } else {
          return [updatedOptions];
        }
      });
    }
    addItem(options);
  };

  const addItem = (newItem) => {
    // Check if the item with the same uniqueId already exists
    const index = allEditedRowsPlanning.findIndex((item) => item.UniqueID === newItem.UniqueID);
    if (index >= 0) {
      // If it exists, update the existing object
      const updatedItems = [...allEditedRowsPlanning];
      updatedItems[index] = newItem; // Update the object at the found index
      setAllEditedRowsPlanning(updatedItems);
    } else {
      // If it doesn't exist, add it to the array
      setAllEditedRowsPlanning((prevItems) => [...prevItems, newItem]);
    }
  };

  const handleNavigationTab = () => {
    if (activeSection === "TaskList") {
      setActiveSection("ProjectList");
      setActiveTable("ProjectList");
      setActiveTabSection("ProjectList");
      setIsProjectListTab(true);
      setShowCloseDialog(false);
      setSaveChangesOption(false);
      setReset(true);
    } else if (activeSection === "ProjectList") {
      setActiveSection("TaskList");
      setActiveTable("TaskList");
      setActiveTabSection("TaskList")
      setIsProjectListTab(false);
      setShowCloseDialog(false);
      setSaveChangesOption(false);
      setReset(true);
    }
  };

  const handleContinue = () => {
    if (changingTab) {
      setIsTaskData([]);
      setIsProjectData([]);
      setSaveFlag(false);
      setShowDraftDialog(false);
      setTabName(changingTab);
      navigate(`/capacityManagement/${changingTab}`);
      setChangingTab();
    } else {
      setIsTaskData([]);
      setIsProjectData([]);
      setSaveFlag(false);
      setApplyFilters(true);
      setShowDraftDialog(false);
    }
  };

  const showToastMesssage = (summary, severity) => {
    toast.current.show({
      severity: severity,
      summary: summary,
      life: 3000,
    });
  };

  useEffect(() => {
    if (loadTaskTable && payload && Object.keys(payload)?.length) {
      setLoader(true);
      clearAppliedFilters();
      fetchData(payload);
      setReset(true);
      setLoadTaskTable(false);
    } else if (loadProjectTable && payload && Object.keys(payload)?.length) {
      setLoader(true);
      clearAppliedFilters();
      fetchProjectListData(payload);
      setReset(true);
      setLoadProjectTable(false);
    }
  }, [loadTaskTable, loadProjectTable, payload]);

  useEffect(() => {
    if (Toggle) {
      document.getElementsByClassName("tab-content booking-tabs")?.[0] &&
        document
          .getElementsByClassName("tab-content booking-tabs")?.[0]
          .addEventListener("scroll", () => {
            if (!AcpService.isUBN(op?.current) || op?.current != null) {
              op?.current?.hide();
            }
          });
      document.getElementsByClassName("p-datatable-wrapper")?.[0] &&
        document
          .getElementsByClassName("p-datatable-wrapper")?.[0]
          .addEventListener("scroll", () => {
            if (!AcpService.isUBN(op?.current) || op?.current != null) {
              op?.current?.hide();
            }
          });
    }
  }, [Toggle]);

  const ColumnHeader = (options, keyId, col) => {
    const frozenColumns = getFrozenColumnNames(activeSection);
    return (
      <>
        {options === "SelectAll" ? (
          <>
            <div className="select-all-checkbox align-items-center">
              <input
                type="checkbox"
                checked={selectAllChecked}
                onChange={
                  activeSection === "ProjectList" ? handleProjectSelectAll : handleTaskSelectAll
                }
                className="p-checkbox-box p-highlight"
                disabled={!checkReadWriteAccess}
              />
            </div>
          </>
        ) : (
          <>
            <div className={`flex-display ${frozenColumns?.includes(options) ? "text-bold" : ""}`} key={keyId}>
              <img
                src={selectedFields[options]?.[0] ? blueFilter : filter}
                alt="Column Filter"
                key={keyId}
                onClick={(e) => {
                  setToggle(!Toggle);
                  projectNameOnClick(e, options);
                }}
                className="columnFilterIcon"
              />
              {
                <span className="columnFilterIcon">
                  {options === "Owner" && "Owner"}
                  {options === "Slack" && "Slack"}
                  {options === "BufferToWork" && "Buffer:Work"}
                  {options === "TaskName" && "Task Name"}
                  {options === "ProjectID" && "Project ID"}
                  {options === "ProjectName" && "Project Name"}
                  {options === "EstimatedOfPOAs" && "#of POAs"}
                  {options === "No_Of_Waves" && "# of Waves"}
                  {options === "ProjectState" && "Project State"}
                  {options === "CurrentStartDate" && "Current Start Date"}
                  {options === "EstimatedAWReadiness" && "Actual AW Fullkit Readiness date (KO)"}
                  {(options === "Buffer" || options === "RemainingBuffer") && "Buffer"}
                  {(options === "Projected_FA_FullKit_Date" ||
                    options === "Projected FA FullKit Date") &&
                    "Projected FA FullKit Date"}
                  {options === "NewStartDate" &&
                    (activeSection === "TaskList" ? "New Start Date" : "New AW Fullkit Readiness Date (KO)")}

                  {options !== "Projected_FA_FullKit_Date" &&
                    options !== "Projected FA FullKit Date" &&
                    options !== "EstimatedAWReadiness" &&
                    options !== "CurrentStartDate" &&
                    options !== "EstimatedOfPOAs" &&
                    options !== "No_Of_Waves" &&
                    options !== "RemainingBuffer" &&
                    options !== "ProjectState" &&
                    options !== "NewStartDate" &&
                    options !== "ProjectName" &&
                    options !== "ProjectID" &&
                    options !== "TaskName" &&
                    options !== "Owner" &&
                    options !== "Slack" &&
                    options !== "Buffer" &&
                    options !== "BufferToWork" &&
                    options !== "AWMTaskID" &&
                    options !== "EndDate" &&
                    options !== "Supplier" &&
                    options !== "TaskType" &&
                    replaceUnderscoreWithSpace(options)}
                </span>
              }
            </div>
          </>
        )}
      </>
    );
  };
  // body template of columns
  const taskbodyTemplate = (options, rowData) => {
    return (
      <TaskbodyTemplate
        optionsVal={options}
        rowDataVal={rowData}
        handleSelect={activeSection === "ProjectList" ? handleSelectProject : handleSelectTask}
        selected={activeSection === "ProjectList" ? selectedProject : selectedTask}
        handleDateChange={handleDateChange}
        setSaveChangesOption={setSaveChangesOption}
        setLoadProjectTable={setLoadProjectTable}
        activeSection={activeSection}
        handleProjectIdClick={handleProjectIdClick}
        setPlanningPageEdited={setPlanningPageEdited}
        showToastMesssage={showToastMesssage}
        checkReadWriteAccess={checkReadWriteAccess}
      />
    );
  };

  const dynamicColumns = (columnNames) => {
    return [
      columnNames?.map((ele, i) => {
        return (
          <Column
            key={ele?.Field_Name}
            field={ele?.Field_Name}
            filterField={ele?.Field_Name}
            filterMatchMode="contains"
            filter={ele?.Field_Name === "SelectAll" ? false : true}
            filterPlaceholder={ele?.Field_Name}
            header={ColumnHeader(ele?.Field_Name, ele?.Field_Name, ele)}
            //header={<ColumnHeader {...headerProps} />}
            // headerStyle={{whiteSpace: "nowrap"}}
            body={taskbodyTemplate}
            columnKey={ele?.Field_Name || i}
            frozen={ele?.freeze}
            className={ele?.freeze ? "fontBoldcolor" : "cursorMove"}
            showFilterMenu={false}
            style={{
              width: ele?.freeze
                ? ele?.Field_Name === "SelectAll"
                  ? "50px"
                  : ele?.Field_Name === "Project Name"
                    ? "200px"
                    : ele?.width
                : ele?.width,
              textOverflow: "ellipsis",
              maxWidth: `${ele?.Field_Name?.length * 12}px`,
              minWidth: "80px",
              whiteSpace: capacityPlanWrapFreeText ? 'normal' : 'nowrap',
              wordBreak: capacityPlanWrapFreeText ? 'break-word': 'unset',
              overflow: capacityPlanWrapFreeText ? 'unset' : 'hidden',
              textOverflow: capacityPlanWrapFreeText ? 'unset' : 'ellipsis',
            }}
          />
        );
      }),
    ];
  };

  useEffect(() => {
    setAllEditedRowsPlanning([]);
    if (reset) {
      if (activeSection === "TaskList") {
        if (!sortData?.length) {
          setTaskData([]);
        }
        const cleanedTaskData = acpPlanningData?.map((task, i) => {
          for (let item of isTaskData) {
            if (item.AWMTaskID === task.AWMTaskID) {
              task.Slack = item.tempSlack;
              task.UniqueID = i;
            }
          }
          const { NewStartDate, tempNewStartDate, isSelected, ...rest } = task;
          return rest;
        });
        if (!sortData?.length) {
          setTaskData(cleanedTaskData);
        }
        dispatch(setStoreAcpTask(cleanedTaskData));
        setIsTaskData([]);

        setSelectedTask([]);
      } else if (activeSection === "ProjectList") {
        if (!sortData?.length) {
          setProjectData([]);
        }
        setInitialProjectData([]);
        const cleanedProjectData = acpPlanningProjectListData?.map((task) => {
          const { NewStartDate, tempNewStartDate, isSelected, ...rest } = task;
          return rest;
        });
        const updatedCleanedProjectData = addUniqueKey(cleanedProjectData);
        dispatch(acpPlanningProjectData(updatedCleanedProjectData));
        setInitialProjectData(updatedCleanedProjectData);
        if (!sortData?.length) {
          setProjectData(updatedCleanedProjectData);
        }
        setSelectedProject([]);
        setIsProjectData([]);
      }

      dispatch(setAcpPlanningTaskDraftData([]));
      dispatch(setAcpPlanningProjectDraftData([]));
      // setFilters([]);
      if (filters?.length && !sortData?.length) {
        const filteredDataWithoutEditedRows = filters?.map((el) => {
          return {
            ...el,
            NewStartDate: "",
            isSelected: false,
            tempNewStartDate: "",
            Slack: el?.tempSlack ? el.tempSlack : 0,
          };
        });
        setFilters(filteredDataWithoutEditedRows);
      }
      setFormValid(false);
      setReset(false);
      setSaveChangesOption(false);
      setSelectAllChecked(false);
    }
  }, [reset]);

  const changeSelectedFieldsForDate = (data) => {
    return data?.map((item) => {
      if (item.CurrentStartDate) {
        item.CurrentStartDate = AcpService.checkIfValidDate(item.CurrentStartDate)
          ? item.CurrentStartDate
          : !AcpService.isUBN(item.CurrentStartDate)
            ? AcpService.convertToShortDateFormat(item.CurrentStartDate)
            : "";
      }
      // adding logic for EstimatedAWPrinter, EstimatedAWReadiness, and ProjectStartDate
      // as there filter was not working, to make it work written this logic
      if (item.EstimatedAWReadiness) {
        item.EstimatedAWReadiness = AcpService.checkIfValidDate(item.EstimatedAWReadiness)
          ? item.EstimatedAWReadiness
          : !AcpService.isUBN(item.EstimatedAWReadiness)
            ? AcpService.convertToShortDateFormat(item.EstimatedAWReadiness)
            : "";
      }
      item.NewStartDate = AcpService.checkIfValidDate(item.NewStartDate)
        ? item.NewStartDate
        : !AcpService.isUBN(item.NewStartDate)
          ? AcpService.convertToShortDateFormat(item.NewStartDate)
          : "";
      return item;
    });
  };

  useEffect(() => {
    setSortData([]);
  }, [activeSection]);

  useEffect(() => {
    const tableData = activeSection === "TaskList" ? taskData : projectData;
    //check the array if NewStartDate null skip that value ,Awm-3217
    const tableDataNew = activeSection === "TaskList" ? isTaskData : isProjectData;
    const updatedValues = removeObjectsWithNullNewStartDate(tableDataNew);
    setDateChangeValue(updatedValues);
    setSelectedColumnName("SelectAll");
    setAllEditedRowsPlanning(updatedValues);
    if (filters?.length) {
      const updatedFilters = filters?.map((el, i) => {
        return {
          ...el,
          NewStartDate: AcpCommonService.isStringDateFormat(el?.NewStartDate)
            ? AcpCommonService.formatDateFromString(el.NewStartDate)
            : el?.NewStartDate,
        };
      });
      if (sortData?.length) {
        onSort(sortData[0], sortData[1], []);
      } else {
        setFilters([...updatedFilters]);
      }
      const updatedTableData = AcpCommonService.updateTableData(
        _.cloneDeep(tableData),
        _.cloneDeep(updatedFilters),
        "UniqueID"
      );
      if (activeSection === "TaskList") {
        setTaskData(updatedTableData);
      } else {
        setProjectData(updatedTableData);
      }
    }
  }, [isTaskData, isProjectData]);

  const handleProjectIdClick = (url) => {
    if (planningPageEdited) {
      setShowDialog(true);
      setTempUrl(url);
    } else {
      navigate(url);
    }
  };

  const onColumnResizeEnd = (event) => {
    const _allColumns = onACPColumnResizeEnd(
      event,
      getLocalStorageACPPlanningColumnNames(activeSection),
      getColumnNames(activeSection)
    );
    localStorage.setItem(
      getLocalStorageACPPlanningColumnNames(activeSection),
      JSON.stringify(_allColumns)
    );
    updateColumnNames(activeSection, _allColumns);
  };

  const storeReorderedColumns = (e) => {
    const tabType = getCustomizeViewFieldsType(activeSection);
    let _allColumns = storeACPReorderedColumns(
      e,
      getLocalStorageACPPlanningColumnNames(activeSection),
      getColumnNames(activeSection)
    );
    const freezeCols = getFrozenColumnNames(activeSection);
    let finalCols = _allColumns.map((el) => el?.Field_Name);
    finalCols = updateInObjectFormat(finalCols, freezeCols);
    updateColumnNames(activeSection, finalCols);
    let _selectedColumnNames = _allColumns.map((el) => el?.Field_Name);
    let _availableColumnNames = getAvailableColumnNames(activeSection)?.map((el) => el?.Field_Name);
    _selectedColumnNames = _selectedColumnNames.filter(function (objFromA) {
      return !freezeCols?.find(function (objFromB) {
        return objFromA === objFromB;
      });
    });

    const customizeviewDataObj = getCustomizeViewObj(
      _availableColumnNames,
      _selectedColumnNames,
      freezeCols
    );
    updateCustomizeViewFields(_availableColumnNames, _selectedColumnNames, freezeCols, tabType);
    localStorage.setItem(tabType, JSON.stringify(customizeviewDataObj));
    setColumnsOrder(PM, tabType, bu, region, false, JSON.stringify(customizeviewDataObj))
      .then(() => { })
      .catch((error) => {
        console.error("Error in storing reordered columns:", error);
      });
  };

  // it will hide warning dialog
  const cancelNavigation = () => {
    setShowDialog(false);
    if (planningPageEdited) {
      setFormValid(true);
      setSaveChangesOption(true);
      if (!saveFlag) {
        setSaveFlag(true);
      }
    }
  };
  // by doing setShowDialog(false) and will call handleUserNotifications ;
  const confirmNavigation = () => {
    setAllEditedRowsPlanning([]);
    if (action === "TabChange") {
      if (currentClick === "TaskList" && !saveChangesOption) {
        setActiveSection("TaskList");
        setActiveTabSection("TaskList")
        setActiveTable("TaskList");
        setIsProjectListTab(false);
        // Force refresh when switching to TaskList after confirmation
        setForceRefresh(prev => prev + 1);
      } else if (currentClick === "ProjectList" && !saveChangesOption) {
        setActiveSection("ProjectList");
        setActiveTabSection("ProjectList");
        setActiveTable("ProjectList");
        setIsProjectListTab(true);
        // Force refresh when switching to ProjectList after confirmation
        setForceRefresh(prev => prev + 1);
      }
      setShowDialog(false);
      setPlanningPageEdited(false);
    } else {
      setPlanningPageEdited(false);
      navigate(tempUrl);
      setTempUrl("");
      markClean();
      setShowDialog(false);
    }
  };

  const handleCustomizeViewFields = (value) => {
    const tabType = getCustomizeViewFieldsType(activeSection);
    setLoader(true);
    if (value === null) {
      const updatedAvailableColumns = convertObjToNormalFormat(
        getInitAvailableColumnNames(activeSection)
      );
      const pgDefaultColumns = formCustomizeObject(
        updatedAvailableColumns,
        getInitFreezeColumn(activeSection),
        getColumnListColumnNames(activeSection)
      );
      updatePgDefaultColumns(activeSection, pgDefaultColumns);
      updateCustomizeViewFields(
        updatedAvailableColumns,
        getColumnListColumnNames(activeSection),
        getInitFreezeColumn(activeSection),
        tabType
      );
    } else {
      updateCustomizeViewFieldsOnly(activeSection, value);
      const updatedHeaders = JSON?.parse(value)?.selectedFields?.fieldsData;
      const latestHeaders = removeSelectAllColumn(updatedHeaders);
      let frozenData = JSON?.parse(value)?.freezedColumns?.fieldsData;
      frozenData = removeSelectAllColumn(frozenData);
      if (!frozenData?.includes("SelectAll")) {
        frozenData = [...getInitFreezeColumn(), ...frozenData];
      }
      updatedFrozenColumn(frozenData);
      const finalColumn = [...(frozenData || []), ...(latestHeaders || [])];
      const items = _.cloneDeep(finalColumn);
      const finalCols = updateInObjectFormat(items, frozenData);
      let availableFieldsToSelectInObjFormat = updateInObjectFormat(
        JSON?.parse(value)?.availableFields?.fieldsData,
        frozenData
      );
      updateAvailableColumnsNames(activeSection, availableFieldsToSelectInObjFormat);
      updateColumnNames(activeSection, finalCols);
    }
    setResetKey((prev) => prev + 1);
    setTableRender(true);
    setTimeout(() => {
      setLoader(false);
    }, 500);
  };

  const resetToPgDefault = () => {
    const tabType = getCustomizeViewFieldsType(activeSection);
    const updatedAvailableColumns = convertObjToNormalFormat(
      getInitAvailableColumnNames(activeSection)
    );
    const finalCols = updateInObjectFormat(
      getColumnListColumnNames(activeSection),
      getInitFreezeColumn(activeSection)
    );
    updateCustomizeViewFields(
      updatedAvailableColumns,
      getColumnListColumnNames(activeSection),
      getInitFreezeColumn(activeSection),
      tabType
    );
    const pgDefaultColumns = formCustomizeObject(
      updatedAvailableColumns,
      getInitFreezeColumn(activeSection),
      getColumnListColumnNames(activeSection)
    );
    updateAvailableColumnsNames(activeSection, getInitAvailableColumnNames(activeSection));
    localStorage.removeItem("ACPPlanningProjectColumnNames");
    updatePgDefaultColumns(activeSection, pgDefaultColumns);
    localStorage.removeItem("ACPPlanningTaskColumnNames");
    updateColumnNames(activeSection, finalCols);
    updatedFrozenColumn(getInitFreezeColumn());
  };

  useEffect(() => {
    if (activeSection === "TaskList") {
      setPlanningData((prevState) => ({ ...prevState, planningData: filters?.length ? filters : taskData }));
    } else {
      setPlanningData((prevState) => ({ ...prevState, planningData: projectData }));
    }
  }, [taskData, projectData]);


  return (
    <>
      <div className="navigationButtonWrapper">
        <button
          onClick={() => handleClick("ProjectList")}
          className={`${activeSection === "ProjectList" ? "activeSection" : ""} navigationButton`}
        >
          <p className="navigationText">ProjectList</p>
        </button>
        <button
          onClick={() => handleClick("TaskList")}
          className={`${activeSection === "TaskList" ? "activeSection" : ""} navigationButton`}
        >
          <p className="navigationText">TaskList</p>
        </button>
      </div>
      {ShowCustomizedView && (
        <CustomizeView
          BU={bu}
          region={region}
          headerName={activeSection}
          showTaskDialog={ShowCustomizedView}
          resetToPgDefault={resetToPgDefault}
          allColumns={getColumnNames(activeSection)}
          setCustomizeViewFields={handleCustomizeViewFields}
          pgDefaultColumns={getPgDefaultValue(activeSection)}
          setFrozenColumn={getFrozenColumnNames(activeSection)}
          availableFields={getAvailableColumnNames(activeSection)}
          onClose={() => setShowCustomizedView(!ShowCustomizedView)}
          customizeViewFields={getCustomizeViewFieldsValue(activeSection)}
        />
      )}
      <div className="taskAndProjectDetails myProjectAnddAllProjectList data-table-checkbox-column">
        <ACPFilter
          op={op}
          onSort={onSort}
          filters={filters}
          pageName="planning"
          sortData={sortData}
          setFilters={setFilters}
          projectData={
            activeSection === "TaskList"
              ? changeSelectedFieldsForDate(taskData)
              : changeSelectedFieldsForDate(projectData)
          }
          selectedFields={selectedFields}
          selectedColumnName={selectedColumnName}
          onGlobalFilterChange={onGlobalFilterChange}
          setSelectedColumnName={setSelectedColumnName}
          clearColumnWiseFilter={clearColumnWiseFilter}
        />
        <LoadingOverlay active={loader} spinner text="" className="overlay-loader">
          {<Toast ref={toast} position="top-center" />}
          {activeSection === "TaskList" && taskData?.length > 0 ? (
            <>
              {TaskColumnNames?.length > 0 && (
                <DataTableGrid
                  data={conditionMatched ? [] : filters?.length ? filters : taskData}
                  isSearch={isSearch}
                  resetKey={resetKey}
                  selected={selectedTask}
                  //key={tableRender ? `"Project_ID" + timestamp+ ${resetKey}` : `${resetKey}`}
                  // frozenValue={taskDraftChanges}
                  onColumnResizeEnd={onColumnResizeEnd}
                  storeReorderedColumns={storeReorderedColumns}
                >
                  {dynamicColumns(TaskColumnNames)}
                </DataTableGrid>
              )}
            </>
          ) : (
            activeSection === "TaskList" && (
              <div className="columnHeader item-center">
                No Task Data Available for selected date range!
              </div>
            )
          )}
          {activeSection === "ProjectList" && projectData?.length > 0 ? (
            <DataTableGrid
              // data={filters?.length ? filters : projectData}
              data={conditionMatched ? [] : filters?.length ? filters : projectData}
              isSearch={isSearch}
              resetKey={resetKey}
              selected={selectedProject}
              //key={tableRender ? `"Project_ID" + timestamp+ ${resetKey}` : `${resetKey}`}
              //frozenValue={projectDraftChanges}
              onColumnResizeEnd={onColumnResizeEnd}
              storeReorderedColumns={storeReorderedColumns}
            >
              {dynamicColumns(ProjectColumnNames)}
            </DataTableGrid>
          ) : (
            activeSection === "ProjectList" && (
              <div className="columnHeader item-center">
                No Project Data Available for selected date range!
              </div>
            )
          )}
          {showCloseDialog && (
            <AcpCloseDialog
              setShowCloseDialog={setShowCloseDialog}
              showCloseDialog={showCloseDialog}
              handleNavigationTab={handleNavigationTab}
              popupCloseMessageText={SaveChangesConfirmation}
            />
          )}
          {showDraftDialog && (
            <AcpCloseDialog
              setShowCloseDialog={setShowDraftDialog}
              showCloseDialog={showDraftDialog}
              handleNavigationTab={handleContinue}
              popupCloseMessageText={SaveChangesConfirmation}
            />
          )}
        </LoadingOverlay>
      </div>
      {/* UnsavedChangesDialog popup*/}
      <UnsavedChangesDialog
        visible={showDialog}
        onCancel={cancelNavigation}
        onConfirm={confirmNavigation}
      />
    </>
  );
};

export default TaskAndProjectListNavigation;
